import { Button } from '@abb/common-ux';
import * as ServiceActionCreators from '@module/license/actionCreators/licenseAllowanceActionCreators';
import * as SiteLicenseActionCreators from '@module/license/actionCreators/siteLicenseActionCreators';
import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as ActionCreators from '../../actionCreators/hardwareActionCreators';
import { default as CustomerSite } from './CustomerSite';
import { default as ServerTableContainer } from './Hardware/HardwareTableContainer';
import { default as LicenseAllowanceTableContainer } from './LicenseAllowance/LicenseAllowanceTableContainer';
import { default as ServerWithServicesList } from './Machines/MachineList';

/* tslint:disable:no-empty jsx-no-lambda jsx-self-close*/
// TODO: track down anys and type everything
export class SiteLicense extends React.Component<any, any> {
  render() {
    let page = (
      <div>
        <h3>Not Authorized</h3>
        <p>{this.props.userPermissions.email} is not an authorized user. Please contact your supervisor to correct this.</p>
      </div>
    );
    if (this.props.userPermissions.allScopes || (this.props.servicesState.site && this.props.userPermissions.scopes.some((s: string) => s === this.props.servicesState.site.country))) {
      page = (
        <div className='container'>
        <CustomerSite></CustomerSite>
        <LicenseAllowanceTableContainer></LicenseAllowanceTableContainer>
        <ServerTableContainer></ServerTableContainer>
        <ServerWithServicesList></ServerWithServicesList>
        <div className='container'>
          <div className='row bottom-buffer'>
            <div className='text-right'>
              <Button buttonType='primary' buttonSize='default' disabled={!this.props.server.reduce((a: any, b: any) => a || b.serviceAllocations.length > 0, false)} onClick={() => this.props.requestLicenseFile(this.props.match.params.siteId)} >Download ServicePort License File</Button>
            </div>
          </div>
        </div>
      </div>);
    }
    return (
      page
    );

  }

  componentDidMount() {
    this.props.requestServerGet(this.props.match.params.siteId);
    this.props.requestServices(this.props.match.params.siteId);
    this.props.requestServiceTypes(this.props.match.params.siteId);
    this.props.requestOperationalUsagesGet();
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps, mergeProps)(SiteLicense) as any);

export function mapStateToProps(store: any) {
  const { access_token: accessToken } = store.userState.loggedInUser;
  return { ...store.servicesState, ...store.serverState, ...store.serviceOptionsState, ...store.userState, servicesState: store.servicesState, userPermissions: store.userState.userPermissions, accessToken };
}

function mapDispatchToProps(dispatch: any) {
  return {
    requestServerGet: (siteId: number, accessToken: string) => dispatch(ActionCreators.onServerGetRequest(siteId, accessToken)),
    requestServices: (siteId: number, accessToken: string) => dispatch(ServiceActionCreators.onAllocationGetRequest(siteId, accessToken)),
    requestServiceTypes: (siteId: number, accessToken: string) => dispatch(ServiceActionCreators.onNewAllocationGetRequest(siteId, accessToken)),
    requestOperationalUsagesGet: (accessToken: string) => dispatch(ActionCreators.onOperationalUsagesGetRequest(accessToken)),
    requestLicenseFile: (siteId: number, siteName: string, accessToken: string) => dispatch(SiteLicenseActionCreators.onLicenseFileGetRequest(siteId, siteName, accessToken))
  };
}

function mergeProps({ accessToken, site, loggedInUser, ...propsFromState }: any, { requestServerGet, requestServices, requestServiceTypes, requestOperationalUsagesGet, requestLicenseFile, ...propsFromDispatch }: any, ownProps: any) {
  return {
    ...propsFromState,
    ...propsFromDispatch,
    ...ownProps,
    requestServerGet: (siteId: number) => requestServerGet(siteId, accessToken),
    requestServices: (siteId: number) => requestServices(siteId, accessToken),
    requestServiceTypes: (siteId: number) => requestServiceTypes(siteId, accessToken),
    requestOperationalUsagesGet: () => requestOperationalUsagesGet(accessToken),
    requestLicenseFile: (siteId: number, siteName: string) => requestLicenseFile(siteId, site.siteName, accessToken)
  };
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/modules/license/components/SiteLicense/SiteLicense.tsx